import { useCallback } from "react"
import { isEmpty, postSubmit } from "@ui-seeker/utils"
import { batch, useSignal } from "@preact/signals-react"

import { BACKEND_APIS, TIME_OUT_STATUS } from "@constants"
import { idNameBatch } from "../@signals"


export default function useModalUpdatesInfo(row) {
    const dataPerSite = useSignal({})
    const isLoading = useSignal(true)

    const getStatusPerSite = useCallback(() => {

        if (!isEmpty(idNameBatch.value) && !dataPerSite.value?.globalData?.ready) {
            postSubmit(`${BACKEND_APIS.EXECUTION_INFO}/status-per-site`, { idBatch: idNameBatch.value.id })
                .then(res => batch(() => {
                    dataPerSite.value = { ...dataPerSite.value, ...res }
                    isLoading.value = false
                })).catch(() => batch(() => {
                    idNameBatch.value = {}
                    isLoading.value = false
                }))

            setTimeout(() => {
                getStatusPerSite()
            }, TIME_OUT_STATUS)
        }

    }, [JSON.stringify(dataPerSite.value), JSON.stringify(idNameBatch.value), isLoading.value])

    const drawerOpener = () => {
        idNameBatch.value = {
            id: row.idBatch,
            name: row.name
        }
    }

    return {
        getStatusPerSite,
        dataPerSite,
        drawerOpener,
        isLoading
    }
}